module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/assessment_achievements/6@2x_35e47a860f32464f624e800e023da36e.png";